import { f7 } from 'framework7-react';
import { FC } from 'react';
import { BannerList } from '../BannerList/BannerList';
import styles from './ServiceStyle.module.css';
import IconGasStation from '@/assets/images/prepaid-menu/icon-gas-station.svg';
import { PageTemplate } from '@/components/uiParts/Template/PageTemplate/PageTemplate';
import { isApp } from '@/config/device';
import { Banner } from '@/types/api/bannerApi';
import { Service as PripaidService } from '@/types/api/serviceApi';

interface ServiceProps {
  id: number;
  categoryName?: string;
  services?: PripaidService[];
  banners?: Banner[];
  handleClickItem: (path_type: number, url: string) => void;
}

const handleClickLink = (path_type: number, path: string) => {
  if (path_type === 1) {
    f7.views.main.router.navigate(path);
  } else if (path_type === 2) {
    if (isApp) {
      // アプリ側で表示を制御するため、path末尾にpath_type=2を追加
      window.open(path + 'path_type=2', '_blank');
      return;
    }
    window.open(path, '_blank');
  } else if (path_type === 0) {
    window.open(path, '_blank');
  }
};

export const Service: FC<ServiceProps> = ({
  id,
  categoryName,
  services,
  banners,
  // handleClickItem,
}) => {
  return (
    <PageTemplate
      pageName="Service"
      title={categoryName || 'サービス'}
      showNavBack
    >
      {services && services?.length > 0 && (
        <div className={styles.serviceTitleWrap}>
          <h2>プリペイドが利用できるサービス</h2>
        </div>
      )}

      {categoryName === 'ガソリンスタンド' && (
        <div className={styles.container}>
          <div
            className={styles.card}
            onClick={async () => handleClickLink(0, 'https://gogo.gs/map/')}
          >
            <img src={IconGasStation} />
            <h4>ガソリンスタンドを検索</h4>
          </div>
        </div>
      )}

      {/* 
      2025/4/23 コメントアウト指示 
      https://rebootkumiai-my.sharepoint.com/:p:/g/personal/yun_reboot_vision/ERi21yPMmX5KlsYOz3OEm88BQPF34ZvHJFnU5fDaAO-09w?e=16Rcch&nav=eyJzSWQiOjI4MCwiY0lkIjozMzMxMDExODZ9
      */}

      {/* <div className={styles.container}>
        {services &&
          services?.map(({ id, service_name, url, link_type }) => (
            <div
              className={styles.card}
              onClick={async () =>
                link_type && url && handleClickItem(link_type, url)
              }
              key={id}
            >
              <h4>{service_name}</h4>
            </div>
          ))}
      </div> */}
      {banners && <BannerList banners={banners} />}
    </PageTemplate>
  );
};
